export const DELIVERY_CHARGE = 2.99;

export * from "./pricing-plan-to-recharge-subscription-property";

export * from "./pricing-plan-quantity";
